/**
 * Query keys for tenant custom emoji. Centralised so the realtime handler and
 * the mutations invalidate exactly the same cache entry.
 */
export const EMOJI_KEYS = {
  all: ['emoji'] as const,
  list: () => [...EMOJI_KEYS.all, 'list'] as const,
  quota: () => [...EMOJI_KEYS.all, 'quota'] as const,
} as const;
